export default {
  now: Date.now,
};
